import Head from "framework/ui/content/Head";
import NavBar from "framework/ui/content/NavBar";
import PageContent from "framework/ui/content/PageContent";
import PageTitle from "framework/ui/content/PageTitle";
import PageSections from "framework/ui/content/PageSections";
import GuestBook from "framework/ui/guestbook/GuestBook";
import Copyright from "framework/ui/content/Copyright";
import Page from "framework/ui/content/Page";
import React from "react";
import logo from "./images/logo.png";
import Gallery from "framework/ui/gallery/Gallery";
import Logo from "framework/ui/content/Logo";
import './css/Gallery.css'
import './css/GuestBook.css'
import './css/NavBar.css'
import './css/PageSections.css'

/**
 * @typedef MyPageProps
 *
 * @property {number} [pageId]  Specific page ID to display.
 */

/**
 * Component for site-specific page contents.
 *
 * @param props {MyPageProps}
 * @returns {JSX.Element}
 * @constructor
 */
export default function MyPage(props) {
  return (
    <Page {...props}>
      <Head/>
      <Logo src={logo}/>
      <NavBar brand='' expand={''}/>
      <PageContent>
        <PageTitle/>
        <PageSections/>
        <GuestBook guestBookId={233} pageId={8701}/>
        <Gallery galleryId={1096} pageId={8700}/>
      </PageContent>
      <Copyright startYear={'2024'} siteName={'EastMarrowstone.com'}/>
    </Page>
  );
}